import { useMutation } from "react-query";
import http from "infra/http";
import { PastaForm, UseSavePastaProps } from "core/features/documentos/typings";

function useSavePastaDocumentoUnidade({ id, unidadeId }: UseSavePastaProps) {
  return useMutation(
    (data: PastaForm) => {
      if (id) {
        //cria pasta
        return http.put(`/v1/documento/pastas/${id}`, data);
      }
      // cria pasta com destino para unidade
      return http.post(`/v1/unidade/${unidadeId}/documento/pastas`, data);
    },
    { retry: false }
  );
}

export default useSavePastaDocumentoUnidade;
